export const ApiConstants = 'https://634bf567317dc96a308e4233.mockapi.io/api/v1';
